import React, { Component } from 'react'

import { Box, Grid, Button, Table, TableBody, TableCell, 
    TableContainer, TableRow, Paper, TableHead, SvgIcon } from '@material-ui/core'

import { cancel } from '../actions/main'
import { browserHistory } from 'react-router'
import './AnswersView.scss'
import './QuizAnswersView.scss'
import { ReactComponent as CorrectIcon } from '../styles/images/correct.svg'
import { ReactComponent as WrongIcon } from '../styles/images/wrong.svg'


export default class QuizAnswersView extends Component{
    constructor(props){
        super(props)        
    }

    handleCancel = () => {
        cancel();
        browserHistory.push("/settings")
    }

    render(){
        const {answers} = this.props
        let sections = [];
        let settings = {};
        if (answers.answerModel && answers.answerModel.decryptedElements) {
            sections = Object.values(answers.answerModel.decryptedElements.quizes);
            settings = answers.answerModel.decryptedElements.settings
        }
        return (
            <Box className="AV-root quiz-response-table">
                <Box m="5px 0 5px 30px">
                    <Box className="preview">Data</Box>
                </Box>                
                <Box m="20px 0 5px 30px" className="preview-box">
                    <Paper className="table-root">
                        <TableContainer className="table-container">
                            <Table className="table" stickyHeader aria-label="Content of selected answer">
                                <TableHead>
                                    <TableRow key={"header"} tabIndex={-1} className="header-cell table-headers">
                                        <TableCell>Question</TableCell>
                                        <TableCell>Answer</TableCell>
                                        {settings.noCorrectAnswers ?  <></> : <TableCell>Result</TableCell>}
                                    </TableRow>
  
                                </TableHead>
                            </Table>
                        </TableContainer>
                        <TableContainer className="table-container">
                            {
                                sections.map((sect, index) =>
                                    <Table className="table" stickyHeader aria-label="Content of selected answer">
                                        <TableHead>
                                            <TableRow key={"section-" + (index + 1)} tabIndex={-1} className="header-cell">
                                                <TableCell >Section {index + 1}:</TableCell>
                                                <TableCell></TableCell>
                                                {settings.noCorrectAnswers ? <></> : <TableCell></TableCell>}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {sect.questions.map((question) => 
                                                <TableRow key={"section-" + (index + 1) + "-q-" + question.originalIndex} tabIndex={-1} >
                                                    {
                                                        (() => {
                                                            if (question.isAnswered) {
                                                                let res = [< TableCell > {question.questionText}</TableCell>]
                                                                let ansList = question.answers.filter(ans => ans.isSelected).map(ans =>
                                                                    <p >{ans.answerText}</p>)
                                                                res.push(<TableCell >{ansList}</TableCell>)
                                                                if (!settings.noCorrectAnswers) {
                                                                    res.push(<TableCell> {question.isOpenQuestion ? <></> : (question.isCorrect ?
                                                                        <SvgIcon component={CorrectIcon} viewBox="0 0 26 26" /> :
                                                                        <SvgIcon component={WrongIcon} viewBox="0 0 26 26" />)
                                                                    }</TableCell>)
                                                                }
                                                                return res;

                                                            }
                                                            else {
                                                                let res = [
                                                                    <TableCell> {question.questionText}</TableCell>,
                                                                    <TableCell></TableCell>,
                                                                ]
                                                                if (!settings.noCorrectAnswers) {
                                                                    res.push(<TableCell> {'Not Answered'}</TableCell>);
                                                                }
                                                                return 
                                                            }
                                                        })()
                                                    }
                                                </TableRow>)}
                                        </TableBody>
                                    </Table>
                                )
                            }
                        </TableContainer>                          
                    </Paper>
                </Box>

            </Box>
        )
    }
}